import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  KpiAlarmCoverageResponse,
  KpiStageDistributionResponse,
  KpiToleranceBreachCoverageResponse,
} from '../models/kpi-snapshot.model';
import { KpiFilters } from '../models/kpi-filters.model';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class KpiService {
  constructor(private apiService: ApiService) {}

  getStageDistribution(
    filters: KpiFilters,
  ): Observable<KpiStageDistributionResponse> {
    return this.apiService.post<KpiStageDistributionResponse>(
      '/Kpi/stage-distribution',
      filters,
    );
  }

  getAlarmCoverage(filters: KpiFilters): Observable<KpiAlarmCoverageResponse> {
    return this.apiService.post<KpiAlarmCoverageResponse>(
      '/Kpi/alarm-coverage',
      filters,
    );
  }

  getToleranceBreachCoverage(
    filters: KpiFilters,
  ): Observable<KpiToleranceBreachCoverageResponse> {
    return this.apiService.post<KpiToleranceBreachCoverageResponse>(
      '/Kpi/tolerance-breach-coverage',
      filters,
    );
  }
}
